import { Currency } from '@/constants/currency'
import { api } from '@/lib/api'

import { EndContractPayload } from '../types'

type LastPaymentQuoteResponse = {
  paymentCycles: Array<{
    paymentCycleStart: string
    paymentCycleEnd: string
    paymentDueDate: string
    paymentAmount: { amount: number; currency: Currency }
  }>
}

export function calculateLastPaymentQuote(data: EndContractPayload) {
  const { contractId, ...rest } = data

  return api.post<LastPaymentQuoteResponse>(
    `/v1/me/contracts/${contractId}/termination-payment-quote`,
    rest,
  )
}
